import { Loader } from '@googlemaps/js-api-loader';

// Single shared Google Maps loader. Options MUST match every other caller
// (RoutePlanner) or the loader throws "called again with different options".
let loadPromise = null;

export function loadGoogleMaps() {
  if (!process.env.REACT_APP_GOOGLE_MAPS_KEY) {
    return Promise.reject(new Error('No Google Maps key configured'));
  }
  if (!loadPromise) {
    const loader = new Loader({
      apiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
      version: 'weekly',
      libraries: ['places', 'geocoding']
    });
    loadPromise = loader.load();
  }
  return loadPromise;
}
